export const normalizeResultValue = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim().toUpperCase();
};

export const validateResultValue = (value) => {
  const normalized = normalizeResultValue(value);
  if (!normalized) return null;
  if (normalized === 'NP' || normalized === 'B') return null;

  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) {
    return 'Usa una calificación de 0 a 100, NP o B.';
  }

  const numeric = Number(normalized);
  if (!Number.isFinite(numeric) || numeric < 0 || numeric > 100) {
    return 'La calificación debe estar entre 0 y 100.';
  }

  return null;
};

export const createResultsDraft = (report = {}) =>
  (report.participantes || []).map((participant) => ({
    id_reporte_participante: Number(participant.id_reporte_participante),
    nombre_completo: participant.nombre_completo || '',
    matricula_alumno: participant.matricula_alumno || '',
    calificacion_diagnostica: normalizeResultValue(
      participant.calificacion_diagnostica,
    ),
    calificacion_final: normalizeResultValue(participant.calificacion_final),
  }));

export const validateResultsRows = (rows = []) => {
  const errors = {};

  rows.forEach((row) => {
    const diagnosticError = validateResultValue(row.calificacion_diagnostica);
    const finalError = validateResultValue(row.calificacion_final);
    if (diagnosticError || finalError) {
      errors[row.id_reporte_participante] = {
        calificacion_diagnostica: diagnosticError,
        calificacion_final: finalError,
      };
    }
  });

  return errors;
};

export const buildResultsPayload = (rows = []) =>
  rows.map((row) => ({
    id_reporte_participante: row.id_reporte_participante,
    calificacion_diagnostica:
      normalizeResultValue(row.calificacion_diagnostica) || null,
    calificacion_final: normalizeResultValue(row.calificacion_final) || null,
  }));

export const calculateLocalResultsSummary = (rows = []) => {
  const numericFinals = [];
  let np = 0;
  let b = 0;
  let pending = 0;

  rows.forEach((row) => {
    const value = normalizeResultValue(row.calificacion_final);
    if (!value) {
      pending += 1;
      return;
    }
    if (value === 'NP') {
      np += 1;
      return;
    }
    if (value === 'B') {
      b += 1;
      return;
    }
    if (!validateResultValue(value)) numericFinals.push(Number(value));
  });

  const average = numericFinals.length
    ? Number(
        (
          numericFinals.reduce((total, value) => total + value, 0) /
          numericFinals.length
        ).toFixed(2),
      )
    : null;

  return {
    total_participantes: rows.length,
    promedio_grupal: average,
    resultados_finales_numericos: numericFinals.length,
    resultados_finales_np: np,
    resultados_finales_b: b,
    resultados_finales_sin_capturar: pending,
  };
};
